import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from 'src/app/environment.service';
import { Observable } from 'rxjs';
import { IMake } from '../../models/google-map-models';

@Injectable({
  providedIn: 'root'
})

export class CarLinkService {

  constructor(private http: HttpClient, private envService: EnvironmentService) { }

  get carLinkURL(): string {
    return (this.envService.isProduction) ? '/route-planner/app/json/carLink.json' : '/app/json/carLink.json';
  }

  getLoadMake(): Observable<IMake[]> {
    return this.http.get<IMake[]>(this.carLinkURL);
  }
}
